import axios from 'axios';

// Track ongoing requests and their promises
const inFlightRequests = new Map();

export const BASE_URL =
  process.env.REACT_APP_BASE_URL;
export const API_KEY = process.env.REACT_APP_API_KEY;

const apiService = async (
  endpoint,
  method = 'GET',
  data = null,
  headers = {},
  token,
  configOverrides = {}
) => {
  const url = `${BASE_URL}${endpoint}`;

  // Use method + url (+ optional data if you want deeper uniqueness)
  const requestKey = `${method}:${url}`;

  // If request is already in flight, return the same promise
  if (inFlightRequests.has(requestKey)) {
    return inFlightRequests.get(requestKey);
  }

  if (API_KEY) {
    headers = {
      ...headers,
      'x-api-key': API_KEY,
    };
  }

  if (token) {
    headers = {
      ...headers,
      Authorization: `Bearer ${token}`,
    };
  }

  const config = {
    method,
    headers: {
      ...headers,
      // 'Access-Control-Allow-Methods': 'DELETE, POST, GET, OPTIONS',
      // 'Access-Control-Allow-Headers':
      // 'Origin, X-Requested-With, Content-Type, Accept',
      // 'Access-Control-Allow-Origin': '*',
    },
    ...configOverrides,
  };

  if (data) {
    if (data instanceof FormData) {
      config.data = data;
      delete config.headers['Content-Type'];
    } else {
      config.data = JSON.stringify(data);
      config.headers['Content-Type'] = 'application/json';
    }
  }

  const requestPromise = axios(url, config)
    .then((response) => {
      const contentType = response.headers['content-type'];
      if (contentType && contentType.startsWith('application/')) {
        return response.data;
      }
      return response.data;
    })
    .catch((error) => {
      console.error('API service error:', error);
      throw error;
    })
    .finally(() => {
      inFlightRequests.delete(requestKey); // Clean up when done
    });

  // Store it before awaiting, so next caller can reuse it
  inFlightRequests.set(requestKey, requestPromise);

  return requestPromise;
};

export default apiService;
